import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID } from 'utils/types';
import css from './Card.css';
import Icon from 'SF/MaterialIcon';
import ReadMoreLessText from '../common/ReadMoreLessText';
import StyledButton from 'common/StyledButton';
import MoreOptions from './MoreOptions';
import { imageStyle } from '../utils/images';
import moment from 'moment';
import Participants from './Participants';
import CardTitle from './CardTitle';
import {getTimeInHours} from "../utils/time";

function Card(props) {

  const getTimeWaiting = time => {
      const {hours, minutes} = getTimeInHours(time);
      if ( hours === 0 && minutes === 0 ) return "Just arrived";
      if ( hours === 0 ) return `${minutes}m wait`;
      return `${hours}h ${minutes}m wait`
  };

  const openFolder = () => props.openStudentFolder(props.studentId, props.isProspect);

  return (
    <div
      data-role="cardContainer"
      className={css['card']}
      style={{border: props.inProgress ? "2px solid #CE4D12" : null}}
      role="application"
    >
      <div className={css['card-header']}>
        {props.studentUuid && <div
          className={css['image']}
          style={imageStyle(props.studentUuid, true)}
          role="img"
          onClick={openFolder}
        />}
        <CardTitle 
          name={props.name} 
          studentId={props.studentId} 
          openStudentFolder={openFolder}
        />
        <div className={css['extra']}>
          {props.inProgress && <StyledButton
            className={css['resume-button']}
            onClick={props.groupSession ? props.onStartGroupSession : props.onStartMeeting}>
            Resume
          </StyledButton>}
          <MoreOptions
            onRemoveFromQueue={props.onRemoveFromQueue}
            onStartMeeting={props.onStartMeeting}
            onEditAppointment={props.onEditAppointment}
            onEditGroupSession={props.onEditGroupSession}
            onStartGroupSession={props.onStartGroupSession}
            inProgress={props.inProgress}
            groupSession={props.groupSession}
          />
        </div>
      </div>
      <ul className={css['card-content']}>
        {props.groupSession && <Participants 
          participants={props.participants} 
          openStudentFolder={props.openStudentFolder}  
        />}
        <li>
          <div>Reason</div>
          <div>
            {props.reason}
            {props.serviceProviderName &&
              <span> with <span className={css['serviceProviderName']}>{props.serviceProviderName}</span></span>
            }
          </div>
        </li>
        {props.serviceName &&
        <li>
          <div>Service</div>
          <div>{props.serviceName}</div>
        </li>}
        {props.startDate && <li>
          <div>Appointment</div>
          <div className={css['start-date']}>
            {moment(props.startDate).format("h:mm A")}
          </div>
        </li>}
        {props.arrivalDate && <li>
          <div>Arrival</div>
          <div className={css['arrival-date']}>
            {moment(props.arrivalDate).format("h:mm A")}
            {props.inProgress ? "" : ` (${getTimeWaiting(props.waitTime)})`}
          </div>
        </li>}
        <li>
          <div>Related Course</div>
          <div className={css['course']}>{props.courseName}</div>
        </li>
        {props.onEditDescription && <li className={css['description']}>
          <div>
            Description
            <StyledButton 
              asLink 
              className={css['description-button']}
              onClick={props.onEditDescription}>
              <Icon icon="edit" aria-label="Edit description" />
            </StyledButton>
            </div>
          <div className={css['read-more']}>
            <ReadMoreLessText text={props.description} />
          </div>
        </li>}
      </ul>
    </div>
  );
}

Card.propTypes = {
  name: PropTypes.string.isRequired,
  studentId: SFEntityID,
  studentUuid: PropTypes.string,
  reason: PropTypes.string.isRequired,
  serviceName: PropTypes.string,
  arrivalDate: PropTypes.string,
  startDate: PropTypes.string,
  courseName: PropTypes.string.isRequired,
  description: PropTypes.string,
  participants: PropTypes.array,
  groupSession: PropTypes.bool,
  inProgress: PropTypes.bool.isRequired,
  isProspect: PropTypes.bool.isRequired,
  onRemoveFromQueue: PropTypes.func,
  onStartMeeting: PropTypes.func,
  onEditDescription: PropTypes.func,
  onEditAppointment: PropTypes.func,
  onEditGroupSession: PropTypes.func,
  onStartGroupSession: PropTypes.func,
  openStudentFolder: PropTypes.func.isRequired,
  waitTime: PropTypes.number,
  serviceProviderName: PropTypes.string
};

export default Card;
